const STORAGE_KEY = 'vue-js-authentication'

export default {
  token (value) {
    var stored = JSON.parse(localStorage.getItem(STORAGE_KEY) || '{}')
    if (value) {
      stored['token'] = value
      localStorage.setItem(STORAGE_KEY, JSON.stringify(stored))
    } else if (value === '') {
      delete stored['token']
      localStorage.setItem(STORAGE_KEY, JSON.stringify(stored))
    }
    return stored['token']
  },

  username (value) {
    var stored = JSON.parse(localStorage.getItem(STORAGE_KEY) || '{}')
    if (value) {
      stored['username'] = value
      localStorage.setItem(STORAGE_KEY, JSON.stringify(stored))
    } else if (value === '') {
      delete stored['username']
      localStorage.setItem(STORAGE_KEY, JSON.stringify(stored))
    }
    return stored['username']
  },

  // User
  instance (value) {
    var stored = JSON.parse(localStorage.getItem(STORAGE_KEY) || '{}')
    if (value) {
      stored['instance'] = value
      localStorage.setItem(STORAGE_KEY, JSON.stringify(stored))
    } else if (value === '') {
      delete stored['instance']
      localStorage.setItem(STORAGE_KEY, JSON.stringify(stored))
    }
    return stored['instance']
  },

  preferences () {
    return this.instance().attributes.preference
  },

  // trash ALL data
  clear () {
    // console.log('clearing auth...')
    this.username('')
    this.token('')
    this.instance('')
  },

  userId () {
    return this.instance() ? parseInt(this.instance().id) : null
  },

  isCurrentUser (id) {
    return parseInt(id) === parseInt(this.instance().id)
  },

  decorate_path_with_access_params (path) {
    return process.env.API_URL + path + '?user_email=' + this.username() + '&user_token=' + this.token()
  }
}



// WEBPACK FOOTER //
// ./src/utilities/authentication.js